const config = {
  title: {
    Colour: 'Colours',
    'Aquaclean Mystic Velvet': 'Aquaclean Mystic Velvet',
    'Fabric (Acor)': 'Fabric (Acor)',
    'Fabric (Alba)': 'Fabric (Alba)',
    'Fabric (Ivy)': 'Fabric (Ivy)',
    'Leather (Carson City)': 'Leather (Carson City)',
    'Linen (Severini)': 'Linen (Severini)',
    'Velvet (Piave)': 'Velvet (Piave)',
    'Viscose mix (Balie)': 'Viscose mix (Balie)',
    'Wool mix (Tweed)': 'Wool mix (Tweed)',
    NoFabric: 'Colours'
  },
  body: {
    Colour: 'Choose from a range of colours that suit your style',
    'Aquaclean Mystic Velvet':
      'Looking for something family friendly? Our accident-proof micro pile velvet is perfect. With advanced Aquaclean technology, all spillages including wine, sauces and ink can be easily wiped away with water.',
    'Easy Velvet':
      'Luxurious and extra durable – this deep pile velvet is sensually soft to the touch and doesn’t mark or crease like traditional velvets.',
    'Fabric (Acor)':
      'Perfect for family homes, this linen-look fabric is hard-wearing with an easy-care finish to aid the removal of water-based stains.',
    'Fabric (Alba)':
      'In a range of bold colours and with a soft, textured feel, this fabric is 100% polyester meaning it’s extremely hard-wearing and easy to clean.',
    'Fabric (Ivy)':
      'This linen-look fabric is hard-wearing with an easy-care finish that is perfect for all families and occasions.',
    'Jade (Velvet)':
      'Run your fingers across our luxe deep pile velvet and feel that softness.  In a cotton/polyester blend it’s an absolute treat.  And, so easy to clean, stains can be removed with water alone.',
    'Leather (Carson City)': '',
    'Leather (Rancho)':
      'Warm colours play across the textured surface of this genuine, high-grade leather. Expertly treated and dyed to allow the original grain structure and natural imperfections to remain visible. Creating an authentic and a sought-after designer finish.',
    'Linen (Severini)': '',
    'Linen (Stonewashed)':
      'Our 100% stonewashed linen is super soft, strong and designed to hang beautifully with a charmingly faded colouring. It feels and handles beautifully as a result of breaking down the natural fibres with stone tumbling.',
    'Smart Wool':
      'The best of both worlds. A versatile wool look fabric with a luxurious velvet touch. Tactile and robust our Smart Wool is washable for added peace of mind.',
    'Velvet (Piave)':
      'Our most luxurious velvet, this cotton blend fabric has a deep pile so is extremely soft to touch while also being hardwearing.',
    'Viscose mix (Balie)':
      'Italian made. Two tone warp & weft to add texture and detail. Viscose component increases durability.',
    'Viscose mix (Matrix)':
      'We just love our Italian made viscose mix that’s got a silk-like drapey quality. With an inherent 2-tone jacquard self-weave pattern in the fabric. Super swishy.',
    'Wool mix (Tweed)':
      'Subtle tweed design. Wool rich fabric blended with polyamide & acrylic for increased resistance to wear & fading.',
    NoFabric: 'Select one of our colours'
  }
}

export default config
